namespace $.$$ {
	type Write = { entry: $shm_hitalama_skills_entry, path: string, text: string, key: string }
	export class $shm_hitalama_skills_source extends $.$shm_hitalama_skills_source {
		private pending = new Map<string, Write>()
		private active = false
		@ $mol_mem_key
		draft( key: string, next?: string | null ): string | null { return next ?? null }
		value( next?: string ): string {
			const entry = this.entry(), path = this.path(), key = entry.link().str + ':' + path
			if( next === undefined ) return this.draft( key ) ?? entry.file_text( path )
			this.draft( key, next ); this.request({ entry, path, key, text: next })
			return next
		}
		@ $mol_action
		request( write: Write ) { this.pending.set( write.key, write ); this.failure( '' ); if( !this.active ) this.start() }
		private start() {
			const write = this.pending.values().next().value!
			this.pending.delete( write.key ); this.active = true; this.saving( true )
			$mol_wire_async( write.entry ).file_write( write.path, write.text ).then( ()=> this.done( write ), error => this.done( write, error ) )
		}
		@ $mol_action
		private done( write: Write, error?: unknown ) {
			this.active = false
			if( !this.pending.has( write.key ) ) {
				if( error ) this.failure( 'Не удалось сохранить файл: ' + this.$.$mol_error_message( error ) )
				else this.draft( write.key, null )
			}
			if( this.pending.size ) this.start(); else this.saving( false )
		}
	}
}
